<div class="dialog-container flex-utility direction-column justify-space-between" appDnd
    (fileDropped)="onFileDropped($event)">
    <div class="dialog-content flex-utility align-center justify-center">
        <div class="title">{{title | uppercase}} </div>
    </div>
    <div class="dropzone">
        <input [disabled]="files.length > 0" [accept]="ACCEPT_FILE" type="file" #fileDropRef id="fileDropRef" multiple
            (change)="fileBrowseHandler($event)" />
        <img src="assets/images/upload_icon.svg" alt="upload_icon">
        <h3> Drag & drop files or <label for="fileDropRef"> Browse </label></h3>
        <h5> Supported formates .csv, .xls, .xlsx </h5>

    </div>
    <div class="files-list">
        <div class="single-file" *ngFor="let file of files; let i = index">
            <div class="info">
                <h4 class="name">
                    {{ file?.name }}
                </h4>
                <app-progress-upload class="progress-wrapper" [progress]="file?.progress"></app-progress-upload>
            </div>
            <div [attr.disabled]="!fileUploaded ? true : null" class="delete" (click)="deleteFile(i)">
                <i title="Cancel" class="material-icons cancel-file">cancel</i>
            </div>
        </div>
    </div>
    <div class="button-container">
        <app-bulgari-button (click)="uploadFile()" [disabled]="!fileUploaded" [customStyle]="'height: 56px;'"
            [full]="true" [type]="'black'" [text]="'BUTTON.UPLOAD' | translate"></app-bulgari-button>
    </div>
</div>